import { type CSSProperties } from "react";

export const DEFAULT_CONTAINER_ID = "monorepo-modal-root";
export const DEFAULT_CLOSE_ON_BACKDROP = true;
export const DEFAULT_CLOSE_ON_ESCAPE = true;
export const DEFAULT_SHOW_CLOSE_BUTTON = true;
export const DEFAULT_BORDER_RADIUS = 24;
export const DEFAULT_PADDING_DESKTOP: Pick<CSSProperties, "paddingTop" | "paddingBottom" | "paddingLeft" | "paddingRight"> = {
    paddingTop: "40px",
    paddingBottom: "40px",
    paddingLeft: "40px",
    paddingRight: "40px",
};
export const DEFAULT_PADDING_MOBILE: Pick<CSSProperties, "paddingTop" | "paddingBottom" | "paddingLeft" | "paddingRight"> = {
    paddingTop: "72px",
    paddingBottom: "32px",
    paddingLeft: "32px",
    paddingRight: "32px",
};
